import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  config: null,
  isShowLoader: false,
  userDetails: null,
  jwtToken: null,
  userType: null,
  isFetchingUserDetails: false,
  userInfo: {
    contactNumber: null,
    email: null,
    type: null,
    username: null,
    userId: null,
    role: null,
    permissions: [],
    status: null,
  },
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveConfig: (state, action) => {
      return { ...state, config: action.payload }
    },
    showHideLoader: (state, action) => {
      return { ...state, isShowLoader: action.payload }
    },

    saveUserDetails: (state, action) => {
      return {
        ...state,
        userDetails: action.payload,
        isFetchingUserDetails: false,
      }
    },
    hanldeAuthState: (state, action) => {
      return { ...state, isFetchingUserDetails: action.payload }
    },
    logout: (state) => {
      return { ...state, userDetails: null, jwtToken: null, userInfo: null }
    },
    saveToken: (state, action) => {
      return { ...state, jwtToken: action.payload }
    },
    saveUserType: (state, action) => {
      return { ...state, userType: action.payload }
    },

    saveAthurised: (state, action) => {
      return { ...state, authorized: action.payload }
    },
    removeToken: (state) => {
      return { ...state, jwtToken: null }
    },
    removeUserType: (state) => {
      return { ...state, userType: null }
    },
    saveUserInfo: (state, action) => {
      return {
        ...state,
        userInfo: {
          contactNumber: action.payload.contactNumber,
          email: action.payload.email,
          type: action.payload.type,
          username: action.payload.username,
          userId: action.payload.userId,
          role: action.payload.role,
          permissions: action.payload.permissions || [],
          status: action.payload.status,
        },
      }
    },
  },
})

export default authSlice.reducer
export const {
  saveConfig,
  saveUserDetails,
  showHideLoader,
  hanldeAuthState,
  logout,
  saveToken,
  removeToken,
  saveUserType,
  saveAthurised,
  removeUserType,
  saveUserInfo,
} = authSlice.actions
